import { Component, OnInit, Renderer2 } from '@angular/core';
import { ServiceService } from '../services/service.service';
import iziToast from 'izitoast';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
declare var $: any
@Component({
  selector: 'app-upgrade-plans',
  templateUrl: './upgrade-plans.component.html',
  styleUrls: ['./upgrade-plans.component.css']
})
export class UpgradePlansComponent implements OnInit {
  showModal = false;
  showModalCurrentPlan = false;
  showModalUpgrade = false;
  // api credentials
  user_id: any;
  api_version: any;
  client_id: any;
  nas_id: any;
  ps_key: any;

  // Plan name list
  plan_name_list: any[] = [];

  refGroupIds: any;
  groupedPlans: any;

  // Plan details
  price: any;
  plan_name: any;
  max_upload: any;
  max_download: any;
  max_time: any;

  // current plan details
  q1_price: any;
  q1_plan_name: any;
  q1_up_kbps_text: any;
  q1_dn_kbps_text: any;

  // Renewal form
  post_code: any;

  isCollapsed = false;

  private overlay: HTMLElement | null = null;
  expire_time: any;
  monthly_dq_sts: any;
  account_state: any;
  planName: any;
  uploadMbps: number;
  downloadMbps: number;
  validity: any;
  planPrice: any;
  constructor(private serviceService: ServiceService, private router: Router, private renderer: Renderer2) { }

  ngOnInit(): void {
    this.user_id = localStorage.getItem('user_name');
    this.api_version = localStorage.getItem('api_version');
    this.client_id = localStorage.getItem('client_id');
    this.nas_id = localStorage.getItem('nas_id');
    this.ps_key = localStorage.getItem('ps_key');

    this.UserDetailes();
    this.getUserPlanList();
  }


  convertKbpsToMbps(value: string): number {
    const kbps = parseFloat(value);
    return isNaN(kbps) ? 0 : kbps / 1000;
  }

  loaderStart() {
    // Create overlay and loader only when API is called
    this.overlay = this.renderer.createElement('div');
    const loader = this.renderer.createElement('div');

    this.renderer.addClass(this.overlay, 'overlay');
    this.renderer.addClass(loader, 'loader');

    loader.innerHTML = 'Loading...'; // Optional text

    this.renderer.appendChild(this.overlay, loader);
    this.renderer.appendChild(document.body, this.overlay);
  }

  loaderEnd() {
    this.renderer.removeChild(document.body, this.overlay);
  }
  openModal(item: any) {

    this.price = item.plan_price;
    this.plan_name = item.rule_name;
    this.max_upload = this.convertKbpsToMbps(item.bw_up_kbps);
    this.max_download = this.convertKbpsToMbps(item.bw_dn_kbps);
    this.max_time = item.time_limit ? item.time_limit : 30;

    this.showModal = true;
  }
  openCurrentPlanModal() {

    this.price = this.q1_price;
    this.plan_name = this.q1_plan_name;
    this.max_upload = this.q1_up_kbps_text;
    this.max_download = this.q1_dn_kbps_text;
    this.max_time = 30;

    this.showModalCurrentPlan = true;
  }

  closeModal() {
    this.showModal = false;
    this.showModalUpgrade = false;
    this.showModalCurrentPlan = false;
  }


  confirmPurchase(plan_name: any, price: any) {
    this.router.navigate(['/invoice-payment'], {
      queryParams: {
        current_plan_name: plan_name,
        current_plan_price: price,
      }

    });
    this.closeModal();
  }


  getUserPlanList() {
    var data: any = new FormData();
    // data.append("api_version", this.api_version);
    // data.append("client_id", this.client_id);
    // data.append("ps_key", this.ps_key);
    // data.append("nas_id", this.nas_id);
    data.append("action_id", "get_bw_plan_list");
    data.append("action", "get_url");
    data.append("req_params", JSON.stringify({ plan_type: "all" }));

    var self = this;
    $.ajax({
      type: "POST",

      url: "https://chettinadlink.com/zoho-apis/",
      cache: false,
      contentType: false,
      processData: false,
      data: data,

      success: function (result: any) {


        if (result.results) {

          self.plan_name_list = result.results;
          self.plan_name_list = result.results
            .filter(item => Number(item.plan_price) > 0)
            .sort((a, b) => Number(a.plan_price) - Number(b.plan_price));
          // console.log("Plan Name List:", self.plan_name_list);

          // Step 2: Group by ref_group_id
          self.groupedPlans = self.plan_name_list.reduce((acc, item) => {
            const groupId = item.ref_group_id || 'Unknown';
            if (!acc[groupId]) {
              acc[groupId] = [];
            }
            acc[groupId].push(item);
            return acc;
          }, {} as { [key: string]: any[] });

          // Step 3: Get all group keys (IDs)
          self.refGroupIds = Object.keys(self.groupedPlans);

        } else {
          console.error("No plan details found for the user.");

        }


      }
    });

  }

  UserDetailes() {
    var data: any = new FormData();
    // data.append("api_version", this.api_version);
    // data.append("client_id", this.client_id);
    // data.append("ps_key", this.ps_key);
    // data.append("nas_id", this.nas_id);
    data.append("action_id", "show_user_id_details");
    data.append("action", "get_url");
    data.append("req_params", JSON.stringify({ user_id: this.user_id }));

    var self = this;
    $.ajax({
      type: "POST",

      url: "https://chettinadlink.com/zoho-apis/",
      cache: false,
      contentType: false,
      processData: false,
      data: data,

      success: function (result: any) {

        if (result.success == true || result.success == "true") {

          let userdetails = result.results;

          // console.log("userdetails", userdetails);
          // Loop through and assign values to class properties
          userdetails.forEach((item: any) => {
            switch (item.fid) {

              case "q1_price":
                self.q1_price = item.value;
                break;
              case "q1_plan_name":
                self.q1_plan_name = item.value;
                break;

              case "q1_up_kbps_text":
                self.q1_up_kbps_text = self.convertKbpsToMbps(item.value);
                break;
              case "q1_dn_kbps_text":
                self.q1_dn_kbps_text = self.convertKbpsToMbps(item.value);
                break;

              case "expire_time":
                self.expire_time = item.value;
                localStorage.setItem('expiredDate', self.expire_time)
                self.expire_time = self.expire_time.split(",")[0];

                break;

              case "monthly_dq_sts":
                self.monthly_dq_sts = item.value;
                self.monthly_dq_sts = self.monthly_dq_sts.split(",")[0];
                break;
              case "account_state":
                self.account_state = item.value;
                break;

            }

          });


        } else {
        }
      }
    });
  }

  isButtonDisabled(planPrice: number): boolean {
    // Disable only if account is Active AND this is the current active plan
    return this.account_state === 'Active' && planPrice === this.q1_price;
  }

  validateAndPay(planName: any, planPrice: any) {
    const q1Price = Number(this.q1_price);
    const selectedPlan = this.plan_name_list.find(
      (plan) => plan.rule_name === planName && Number(plan.plan_price) === Number(planPrice)
    );

    if (!selectedPlan) {
      iziToast.error({
        message: 'Selected plan not found!',
        position: 'topRight'
      });
      return;
    }
    this.planName = planName
    this.planPrice = planPrice
    this.uploadMbps = this.convertKbpsToMbps(selectedPlan.bw_up_kbps);
    this.downloadMbps = this.convertKbpsToMbps(selectedPlan.bw_dn_kbps);
    this.validity = selectedPlan.time_limit ? selectedPlan.time_limit : 30;

    if (Number(planPrice) >= q1Price) {
    this.showModalUpgrade = true;

     } else {
      iziToast.error({
        message: 'This plan is not available. Please contact admin.',
        position: 'topRight'
      });
    }

  }

  invoicePayment(plan_name: any, plan_price: any) {
    // this.loaderStart();
    this.router.navigate(['/invoice-payment'], {
      queryParams: {
        plan_name: plan_name,
        plan_price: plan_price,
      }
    });
    // this.loaderEnd();

  }

  isPayBillEnabled(): boolean {
    if (this.account_state === 'Expired') {
      return true;
    }

    if (this.account_state === 'Active') {
      if (!this.monthly_dq_sts || !this.expire_time) return false;

      const currentYear = new Date().getFullYear();

      // Parse start and end dates
      const startDate = new Date(`${this.monthly_dq_sts} ${currentYear}`);
      const endDate = new Date(`${this.expire_time} ${currentYear}`);

      // Normalize to midnight
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      // Calculate the start of the last 7-day window
      const last7Start = new Date(endDate);
      last7Start.setDate(endDate.getDate() - 6); // Includes end day itself

      return today >= last7Start && today <= endDate;
    }

    return false; // Disabled for all other account states
  }


}
